/**
 * SINGLE SOURCE OF TRUTH for business information.
 * Change values here — never hardcode contact details in components.
 *
 * Public contact email uses the revolinroofing.com domain.
 * Credentials remain disabled until the roofing division verifies them.
 */
export const business = {
  name: "Revolin Roofing",
  parent: "A Revolin Group Company",
  parentUrl: "https://revolingroup.com",
  /** Corporate parent for schema.org parentOrganization @id. */
  corporateParentName: "Mars Innovations Group",
  corporateParentId: "https://marsinnovationsgroup.com/#org",
  corporateParentUrl: "https://marsinnovationsgroup.com",
  domain: "revolinroofing.com",
  url: "https://revolinroofing.com",

  phone: "+1 (778) 851-0830",
  phoneHref: "tel:+17788510830",
  email: "leaks@revolinroofing.com",

  address: {
    locality: "Burnaby",
    region: "BC",
    country: "CA",
  },

  hours: "Monday–Friday, 9:00 AM–6:00 PM; Saturday, 10:00 AM–4:00 PM; Sunday by appointment",

  /** Roofing division operating year (user-confirmed). Distinct from team field experience. */
  establishedYear: 2025,

  /**
   * Credential flags for future gated UI / schema.
   * insured: owner-confirmed $10M CGL. Licence numbers / WCB account / RCABC membership
   * remain unverified — do not invent IDs (see docs/trust-placeholders.md).
   */
  credentials: {
    licensed: false,
    insured: true,
    wcbCovered: false,
    rcabcMember: false,
  },

  /** Verified service footprint. Do not add cities without confirmation. */
  serviceAreas: [
    "Vancouver",
    "Burnaby",
    "Coquitlam",
    "Surrey",
    "Richmond",
    "North Vancouver",
    "West Vancouver",
    "New Westminster",
    "Port Moody",
    "Port Coquitlam",
    "Maple Ridge",
    "Delta",
    "Langley",
    "White Rock",
  ],

  /**
   * When false (default), service pages show assessment CTAs instead of ranges.
   * Internal ROI and planning prices live in docs/internal/ only — never import them here.
   */
  showPublicPricing: false,

  /** Optional service flags retained for operational notes; public catalogue is fully published. */
  optionalServices: {
    emergencyRepair: true,
    flashing: true,
    skylights: true,
    gutters: true,
    newConstruction: false,
    commercial: false,
    strata: false,
  },
} as const;

export type Business = typeof business;
